import { Checkbox } from 'corso-admin-ui';

type CombinesWith = {
  productDiscounts: boolean;
  orderDiscounts: boolean;
  shippingDiscounts: boolean;
};

/**
 * Pure component for the "Combinations" fieldset shared across discount
 * definition forms. The parent wraps this in a single `<Controller>` over the
 * `combinesWith` container path so no generic typing is needed here.
 */
export function CombinationsFieldset({
  value,
  onChange,
}: {
  value: CombinesWith;
  onChange: (next: CombinesWith) => void;
}) {
  const toggle = (key: keyof CombinesWith) => (checked: boolean) =>
    onChange({ ...value, [key]: checked });

  return (
    <fieldset className="flex flex-col gap-3">
      <legend className="mb-2 text-sm leading-6 font-medium text-neutral-800">
        Combinations
      </legend>

      <label
        htmlFor="combines-with-product-discounts"
        className="flex cursor-pointer items-center gap-3 text-sm text-neutral-800"
      >
        <Checkbox
          id="combines-with-product-discounts"
          checked={value.productDiscounts}
          onChange={(e) => toggle('productDiscounts')(e.target.checked)}
        />
        Product discounts
      </label>
      <label
        htmlFor="combines-with-order-discounts"
        className="flex cursor-pointer items-center gap-3 text-sm text-neutral-800"
      >
        <Checkbox
          id="combines-with-order-discounts"
          checked={value.orderDiscounts}
          onChange={(e) => toggle('orderDiscounts')(e.target.checked)}
        />
        Order discounts
      </label>
      <label
        htmlFor="combines-with-shipping-discounts"
        className="flex cursor-pointer items-center gap-3 text-sm text-neutral-800"
      >
        <Checkbox
          id="combines-with-shipping-discounts"
          checked={value.shippingDiscounts}
          onChange={(e) => toggle('shippingDiscounts')(e.target.checked)}
        />
        Shipping discounts
      </label>
    </fieldset>
  );
}
